import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { User } from '../services/api';
import { hasAnyRole, canAccessPage } from '../utils/permissions';

interface Props {
  user: User | null;
  requiredRole?: string;
  requiredRoles?: string[];
  roles?: string[];
  children: React.ReactNode;
  pageContext?: string; // z.B. 'users', 'firms', 'locations', etc.
}

export const PrivateRoute: React.FC<Props> = ({ 
  user, 
  requiredRole, 
  requiredRoles, 
  roles = [], 
  children, 
  pageContext 
}) => {
  const location = useLocation();

  // Speichere die Ziel-URL lokal im sessionStorage, um sie nach Login wiederzufinden
  useEffect(() => {
    if (!user) {
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    }
  }, [user, location]);

  // Prüfe zuerst, ob Benutzer angemeldet ist
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Für Abwärtskompatibilität: requiredRole kann weiterhin benutzt werden
  if (requiredRole && !roles.includes(requiredRole)) {
    return <Navigate to="/events" replace />;
  }

  // Neue Funktionalität: Prüfe, ob der Benutzer mindestens eine der erforderlichen Rollen hat
  if (requiredRoles && requiredRoles.length > 0) {
    const hasRequiredRole = hasAnyRole(roles, requiredRoles);
    if (!hasRequiredRole) {
      return <Navigate to="/events" replace />;
    }
  }

  // Prüfe seitenspezifische Berechtigungen
  if (pageContext && !canAccessPage(roles, pageContext)) {
    return <Navigate to="/events" replace />;
  }

  return <>{children}</>;
};
